import { lazy } from 'react'

export const ChangeProductStateModalAsync = lazy(() =>
    import('./ChangeProductStateModal').then(({ ChangeProductStateModal }) => ({
        default: ChangeProductStateModal
    }))
)
